"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const InstallationProfile_1 = require("../enums/InstallationProfile");
const GetTariffsProduct_1 = tslib_1.__importDefault(require("./GetTariffsProduct"));
class GetTariffsGasProduct extends GetTariffsProduct_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, class_validator_1.Min)(0),
    (0, base_models_1.Docs)({
        example: 600,
        description: 'The expected yearly gas consumption in m3',
    }),
    tslib_1.__metadata("design:type", Number)
], GetTariffsGasProduct.prototype, "consumptionPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '871718518003014972',
        description: `The net area EAN, can be retrieved from EDSN also for non existing customers.
    This determines in which "region" you live, numbered from 01 up to 10.
    For each region there is a different supply rate.
    For example  with the same installation and segment, but different net area, could result in a difference of 0.01 euro in unit price.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsGasProduct.prototype, "netAreaEAN", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(InstallationProfile_1.GasInstallationProfile)),
    (0, base_models_1.Docs)({
        example: InstallationProfile_1.GasInstallationProfile.G1A,
        description: `The profile of the gas meter/installation.
      heavily influences the rates.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetTariffsGasProduct.prototype, "installationProfile", void 0);
exports.default = GetTariffsGasProduct;
